import { getType } from 'typesafe-actions';

import {
  clearNotificationAction,
  NotificationSeverity,
  NotificationsActions,
  showNotificationAction,
} from './actions';

export interface NotificationsState {
  notification: {
    intlId: string;
    severity?: NotificationSeverity;
    closeButtonIntlId?: string;
    message?: string;
    closeButtonText?: string;
  } | null;
}

const initialState = {
  notification: null,
};

export const notificationsReducer = (
  state: NotificationsState = initialState,
  action: NotificationsActions,
): NotificationsState => {
  switch (action.type) {
    case getType(showNotificationAction): {
      return {
        ...state,
        notification: action.payload,
      };
    }
    case getType(clearNotificationAction): {
      return {
        ...state,
        notification: null,
      };
    }
    default: {
      return state;
    }
  }
};
